import Link from 'next/link';

export default ({ showHome = true, dark = false }) => (
  <div
    className={`mx-auto my-10 text-sm font-light text-center ${
      dark ? 'text-gray-800' : 'text-gray-400'
    }`}
  >
    <div>
      &copy; 2020{' '}
      <a href="https://lightningapps.xyz/" className="text-current">
        Lightning Apps
      </a>
      &nbsp; &nbsp; &mdash; &nbsp; &nbsp;
      {showHome && (
        <>
          <Link href="/" className={`${dark ? 'text-gray-600' : ''}`}>
            Home
          </Link>{' '}
          /{' '}
        </>
      )}
      <Link href="/terms" className={`${dark ? 'text-gray-600' : ''}`}>
        Terms
      </Link>{' '}
      /{' '}
      <Link href="/privacy" className={`${dark ? 'text-gray-600' : ''}`}>
        Privacy
      </Link>
    </div>
  </div>
);
